import React, { useState } from 'react';
import { User, Lock, Eye, EyeOff, ArrowRight } from 'lucide-react';
import logo from "../images/logo.png";
import MultiAcessoService from '../../modules/services/MultiAcessoService';
import '../css/login.css';

function Login({ onSuccess }) {
    const [usuario, setUsuario] = useState('');
    const [senha, setSenha] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!usuario.trim() || !senha) {
            setErro('Preencha usuário e senha.');
            return;
        }

        setErro('');
        setCarregando(true);
        try {
            // Senha expirada não entra mais aqui como erro — o backend autentica normalmente e
            // sinaliza `senhaExpirada` no conteúdo; onSuccess (App.js) decide mostrar a tela de
            // trocar senha antes de liberar o resto do portal.
            const conteudo = await MultiAcessoService.autenticar(usuario.trim(), senha);
            onSuccess(conteudo);
        } catch (error) {
            setErro(error.message || 'Não foi possível entrar. Tente novamente.');
        } finally {
            setCarregando(false);
        }
    };

    return (
        <main className="login-page">
            <aside className="login-brand-panel">
                <div className="login-brand-mark">
                    <span className="login-wordmark"> 
                        <img src={logo} alt="Logo" className="logo" />
                    </span>
                </div>

                <div className="login-brand-headline">
                    <h1>Bem-vindo(a) ao seu portal GAM.</h1>
                    <p>Acesse serviços com segurança e agilidade.</p>
                </div>

                <div className="login-brand-footer">
                    <div className="login-brand-footer-row">
                        <Lock size={16} />
                        Conexão segura · Criptografia SSL
                    </div>
                    <div className="login-brand-copyright">© 2026 GAM. Todos os direitos reservados.</div>
                </div>
            </aside>

            <section className="login-form-panel">
                <div className="login-form-wrap">
                    <div className="login-form-header">
                        <h2>Entrar na sua conta</h2>
                        <p>Informe suas credenciais para acessar o portal.</p>
                    </div>

                    <form className="login-form" onSubmit={handleSubmit} noValidate>
                        <div className="login-field">
                            <label htmlFor="login-usuario">Usuário</label>
                            <div className="login-input-wrap">
                                <User className="login-ico-lead" size={18} />
                                <input
                                    id="login-usuario"
                                    type="text"
                                    placeholder="usuário"
                                    autoComplete="username"
                                    value={usuario}
                                    onChange={(event) => setUsuario(event.target.value)}
                                    disabled={carregando}
                                />
                            </div>
                        </div>

                        <div className="login-field">
                            <label htmlFor="login-senha">Senha</label>
                            <div className="login-input-wrap">
                                <Lock className="login-ico-lead" size={18} />
                                <input
                                    id="login-senha"
                                    type={mostrarSenha ? 'text' : 'password'}
                                    placeholder="Digite sua senha"
                                    autoComplete="current-password"
                                    value={senha}
                                    onChange={(event) => setSenha(event.target.value)}
                                    disabled={carregando}
                                />
                                <button
                                    type="button"
                                    className="login-toggle-pwd"
                                    aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                                    onClick={() => setMostrarSenha((valor) => !valor)}
                                >
                                    {mostrarSenha ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                        </div>

                        <div className="field-row" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <a href="/esqueci-senha" className="login-help-block" style={{ margin: 0 }}>
                                Esqueci minha senha
                            </a>
                        </div>

                        {erro && <div className="login-erro">{erro}</div>}

                        <button type="submit" className="login-btn-submit" disabled={carregando}>
                            {carregando ? 'Entrando...' : 'Entrar'}
                            <ArrowRight size={16} />
                        </button>
                    </form>

                    <div className="login-help-block">
                        Ainda não tem acesso? <a href="/cadastro">Cadastre-se</a>.<br />
                        Em caso de dúvidas, fale com o SAC GAM.
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Login;
